// module
import React from 'react';
// ui library
import {
  View,
  ChevronLeftIcon,
  ChevronRightIcon,
  Text,
} from '@upstox/upstox-ui';
// typings
import { Props } from './typings';

const ModalPagination: React.FC<Props> = ({
  currentIndex,
  totalCount,
  previous,
  next,
}) => (
  <View
    flex
    justifyContent={totalCount > 1 ? 'space-between' : 'center'}
    alignItems="center"
  >
    {totalCount > 1 ? (
      <React.Fragment>
        <ChevronLeftIcon
          size="large"
          onClick={previous}
          style={{
            cursor: 'pointer',
          }}
        />
        <Text size="m" weight="bold" lineHeight="heading3">
          {`${currentIndex}/${totalCount} Notices`}
        </Text>
        <ChevronRightIcon
          size="large"
          onClick={next}
          style={{
            cursor: 'pointer',
          }}
        />
      </React.Fragment>
    ) : (
      <Text size="m" weight="bold" align="center" lineHeight="heading3">
        Notice
      </Text>
    )}
  </View>
);

export default ModalPagination;
